import { ReactNode, useCallback, useRef, useState } from 'react';

import { CommandListNestedRouterPath, CommandListNestedRouterPathEnum } from './commandRoutes';
import { GroupContextActionType, ShortcutMenuContext, ShortcutMenuContextAction } from './ShortcutMenuContext';

interface ShortcutMenuProviderProps {
    children: ReactNode;
}

export const ShortcutMenuProvider = ({ children }: ShortcutMenuProviderProps) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined);
    const [pages, setPages] = useState<CommandListNestedRouterPath[]>([]);
    const [groupContextActionType, setGroupContextActionType] = useState<GroupContextActionType | null>(null);
    const [contextActions, setContextActions] = useState<ShortcutMenuContextAction[]>([]);
    const contextActionHandlersRef = useRef<Record<string, () => void>>({});

    const openGroupContextSelection = () => {
        setOpen(true);
        setSearch('');
        setSelectedValue(undefined);
        setPages([CommandListNestedRouterPathEnum.CONTEXT]);
        setGroupContextActionType(null);
    };

    const getContextActionHandler = useCallback((id: string) => contextActionHandlersRef.current[id], []);
    const setContextActionHandlers = useCallback((handlers: Record<string, () => void>) => {
        contextActionHandlersRef.current = handlers;
    }, []);
    const clearContextActionHandlers = useCallback(() => {
        contextActionHandlersRef.current = {};
    }, []);

    return (
        <ShortcutMenuContext.Provider
            value={{
                open,
                setOpen,
                search,
                setSearch,
                selectedValue,
                setSelectedValue,
                pages,
                setPages,
                groupContextActionType,
                setGroupContextActionType,
                contextActions,
                setContextActions,
                getContextActionHandler,
                setContextActionHandlers,
                clearContextActionHandlers,
                openGroupContextSelection,
            }}
        >
            {children}
        </ShortcutMenuContext.Provider>
    );
};
